import CanvasDialog from './CanvasDialog';

export default CanvasDialog;
